import ko from 'knockout';

export default class ViewModel {
  constructor({
    i18n,
  }) {
    this.i18n = i18n;
    this.negativeKeywordList = ko.observable('');
  }

  updateAttribute() {
    this.negativeKeywordList(this.i18n.getString('Negative_Keyword_List'));
  }
}
